export interface StoreAbortController {
	abort: () => Promise<void>;
}

export interface StoreAbortControllerSettings {
	storeAbortController: StoreAbortController;
	confirmAbort: () => void;
	abortController: AbortController;
}

export const createStoreAbortController = (): StoreAbortControllerSettings => {
	const abortController = new AbortController();
	let resolveAbort: () => void;

	const confirmAbort = () => {
		resolveAbort();
	};

	const abort = () => {
		abortController.abort();
		return new Promise<void>((resolve) => {
			resolveAbort = resolve;
		});
	};

	return {
		abortController,
		storeAbortController: { abort },
		confirmAbort,
	};
};
